import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { LandingComponent } from './landing/landing/landing.component';
import { LandingNtripCasterComponent } from './landing/landing-ntrip-caster/landing-ntrip-caster.component';
import { LandingPpkDownloaderComponent } from './landing/landing-ppk-downloader/landing-ppk-downloader.component';
import { LandingRtkBaseAnalyzerComponent } from './landing/landing-rtk-base-analyzer/landing-rtk-base-analyzer.component';
import { LandingAboutUsComponent } from './landing/landing-about-us/landing-about-us.component';
import { LandingContactUsComponent } from './landing/landing-contact-us/landing-contact-us.component';
import { LandingCopyrightComponent } from './landing/landing-copyright/landing-copyright.component';
import { LandingDataProcessingComponent } from './landing/landing-data-processing/landing-data-processing.component';
import { LandingDisclaimerComponent } from './landing/landing-disclaimer/landing-disclaimer.component';
import { LandingRefundPolicyComponent } from './landing/landing-refund-policy/landing-refund-policy.component';
import { LandingSecurityPrivacyComponent } from './landing/landing-security-privacy/landing-security-privacy.component';
import { LandingTermsConditionsComponent } from './landing/landing-terms-conditions/landing-terms-conditions.component';
import { LicenseComponent } from './pages/license/license.component';
import { AuthGuard } from './guards/auth.guard';
import { LandingWhatsNewComponent } from './landing/landing-whats-new/landing-whats-new.component';
import { LandingQuickStartComponent } from './landing/landing-quick-start/landing-quick-start.component';
// duplicates removed
import { DownloaderProGuard } from './guards/downloader-pro.guard';
import { ExternalMountpointConnectionsComponent } from './pages/external-mountpoint-connections/external-mountpoint-connections.component';
import { PpkDownloaderProComponent } from './pages/ppk-downloader-pro/ppk-downloader-pro.component';
import { AnalyzerOrDownloaderGuard } from './guards/analyzer-or-downloader.guard';
import { AnalyzerProGuard } from './guards/analyzer-pro.guard';
import { RtkBaseAnalyzerProComponent } from './pages/rtk-base-analyzer-pro/rtk-base-analyzer-pro.component';
import { LandingRedirectGuard } from './guards/landing-redirect.guard';
import { PpkStudioComponent } from './pages/ppk-studio/ppk-studio.component';

const routes: Routes = [
  // Public landing page. If already logged in, LandingRedirectGuard will send user to /ppk-studio.
  // Using a component (not redirectTo) also preserves Auth0 callback query params (?code=...).
  { path: '', pathMatch: 'full', component: LandingComponent, canActivate: [LandingRedirectGuard] },
  { path: 'user-profile', component: UserProfileComponent, canActivate: [AuthGuard] },
  { path: 'license', component: LicenseComponent, canActivate: [AuthGuard] },
  { path: 'ext-mountpoint-connections', component: ExternalMountpointConnectionsComponent, canActivate: [AuthGuard, AnalyzerOrDownloaderGuard] },
  { path: 'ppk-downloader-pro', component: PpkDownloaderProComponent, canActivate: [AuthGuard, DownloaderProGuard] },
  { path: 'rtk-base-analyzer-pro', component: RtkBaseAnalyzerProComponent, canActivate: [AuthGuard, AnalyzerProGuard] },
  { path: 'ppk-studio', component: PpkStudioComponent, canActivate: [AuthGuard] },
  { path: 'about-us', component: LandingAboutUsComponent },
  { path: 'landing-ntrip-caster', component: LandingNtripCasterComponent },
  { path: 'landing-whats-new', component: LandingWhatsNewComponent },
  { path: 'landing-quick-start', component: LandingQuickStartComponent },
  { path: 'landing-rtk-base-analyzer', component: LandingRtkBaseAnalyzerComponent },
  { path: 'landing-ppk-downloader', component: LandingPpkDownloaderComponent },
  { path: 'contact-us', component: LandingContactUsComponent },
  { path: 'copyright', component: LandingCopyrightComponent },
  { path: 'data-processing', component: LandingDataProcessingComponent },
  { path: 'disclaimer', component: LandingDisclaimerComponent },
  { path: 'refund-policy', component: LandingRefundPolicyComponent },
  { path: 'security-privacy', component: LandingSecurityPrivacyComponent },
  { path: 'terms-conditions', component: LandingTermsConditionsComponent },
  // Unknown routes go to landing (logged-in users will still be redirected to /ppk-studio by the guard).
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollOffset: [0, 72], onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
